import * as React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardStyle } from './Card';
import { Company } from '../company';

export interface CompanyCardProps {
  company: Company;
}

const cardBackground = (company: Company) => {
  return (company.theme && company.theme.background) || '#1D1D1D';
};

const cardBody = (company: Company) => {
  return (company.theme && company.theme.body) || '#FFFFFF';
};

const cardKey = (company: Company) => {
  return (company.theme && company.theme.key) || '#FFFFFF';
};

const location = (company: Company) => {
  if (!company.location.city) {
    return company.location.country;
  }

  return [company.location.city, company.location.country].join(', ');
};

export const CompanyCard = ({ company }: CompanyCardProps) => (
  <Card className={`${CardStyle.Default} animated fadeIn`}>
    <h6 className="ma0 mb3 lh-copy f6 ttu black">Manage Company</h6>

    <Link
      to="/company"
      className="db link grow relative w-70 br3 overflow-hidden shadow-4"
    >
      <div className="aspect-ratio aspect-ratio--1x1">
        <div
          className="aspect-ratio--object cover"
          style={{
            backgroundImage: `url(${company.image_identifier ||
              '/images/favourite.png'})`,
            backgroundPosition: 'center',
          }}
        />
      </div>
      <div style={{ backgroundColor: cardBackground(company) }}>
        <h5
          className="ma0 ph2 ttu f7"
          style={{ color: cardBody(company), opacity: 0.5 }}
        >
          {location(company)}
        </h5>
        <h3 className="ma0 pa2 pb4 f4" style={{ color: cardKey(company) }}>
          {company.name}
        </h3>
      </div>
    </Link>

    <div className="ma0 mt3 lh-copy f6 ttu">&nbsp;</div>
  </Card>
);

export default CompanyCard;
